import { useFormContext } from 'react-hook-form';

import type { BlockedRecordProctorFormInput } from './blocked-record-proctor-form-schema';

export const useBlockedRecordProctorFormContext = useFormContext<BlockedRecordProctorFormInput>;
